import React from "react";

import Fab from "@material-ui/core/Fab";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default ({ faIcon, backgroundColor, iconColor, elevation }) => {
  return (
    <Fab
      size="small"
      style={{
        backgroundColor: backgroundColor || "#2181CD",
        color: iconColor || "#fff",
      }}
      aria-label="add"
      disableElevation={!elevation}
    >
      <FontAwesomeIcon icon={faIcon} />
    </Fab>
  );
};
